'use client'

import { useNav } from "@/context/navContext";
import { nav, nav2 } from "@/type/nav_types";
import InqueryFooter from "../etc/inqueryFooter";
import { AuthContext } from "@/context/authContext";
import { useContext } from "react";
import { SignContext } from "@/context/signContext";
import export_icon from "@/public/icon/export_icon.png"
import SwitchTheme from "@/components/etc/themeSwitch";
import SiteShare from "@/components/etc/siteShare";
import logoutimage from "@/public/image/etc/logout.png"
import { FloatContext } from "@/context/moFloatMenuContext";
import { DeviceContext } from "@/context/deviceContext";
import { useTranslations } from "next-intl";
import { MODE } from "@/appConfig";
import { SettingContext } from "@/context/siteContext";


export default function FloatMenuBottom(
    { isActive, setActive, setShowChat }: 
    { isActive: boolean, setActive: Function, setShowChat:Function }) {
    const { movePage } = useNav()
    const { user, logout } = useContext(AuthContext)
    const { SetLoginShow, SetSignUpShow } = useContext(SignContext)
    const { SetMypageShow } = useContext(FloatContext)

    const { setting } = useContext(SettingContext)
    
    const { theme } = useContext(DeviceContext)

    const t = useTranslations("Text")
    const p = useTranslations("PageTitle")

    function moveAndHide(path: string){

        if(path == "chat"){
            setShowChat(true)
            setActive(false)
            return;
        }else if(path == "home"){
            movePage("/")
            setActive(false)
            return;
        }
        movePage(path)
        setActive(false)
    }

    
    function handleLogout() {
        setActive(false)
        logout({ suppressRedirect: true });
    }
    
    return (
        <>
            {isActive && <div className="float-left-menu-backdrop" onClick={e => setActive(false)}></div>}
            <div className={`float-bottom-menu ${isActive ? "show" : ""}`}>
                
                {
                    <div className={`m-b-15`}>
                        <p className="bottom-section m-b-8">{t("회원 정보")}</p>
                        <div className="login-auth">
                        {user.is_authenticated
                            ? <>
                                <button className={`${theme == "dark" ? "login" : "sign-in"}`} onClick={e=> {setActive(false);SetMypageShow(true);}}>{t("마이페이지")}</button>
                                <button className={`${theme == "light" ? "login" : "sign-in"}`} onClick={e=> handleLogout()}>
                                    {t("로그아웃")}&nbsp;
                                    <img src={logoutimage.src} style={{width:"20px", filter:"var(--icon-highlight)"}} />
                                </button>
                              </>
                            : <>
                                <button className="login" onClick={e=> {SetLoginShow(true);}}>{t("로그인")}</button>
                                <button className="sign-in" onClick={e=> SetSignUpShow(true)}>{t("회원가입")}</button>
                              </>
                        }
                        </div>
                    </div>
                }
                <div className="nav">
                    <div className="bottom-section flex between p-t-0 m-b-8 m-t-7">
                        <div className="keep-word">{t("전체서비스")}</div>

                        <div className={`flex flex_end`}>
                            <div className={`m-r-6`} style={{transform:"translateY(-2px"}}>
                                <SwitchTheme />
                            </div>
                            <div className={`hambug`}>
                                <SiteShare />
                            </div>
                        </div>
                    </div>
                    <ul>
                        {
                            nav2.map((nav, index) => (
                                <li key={index} onClick={e => moveAndHide(nav.path)}>
                                    <div className="inner">
                                        <div className="nav-icon">
                                            <span className={`--menu ${nav.icon}`}></span>
                                        </div>
                                        <p>{p(nav.name)}</p>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
                <InqueryFooter />

                {
                    MODE == "TEST"
                    ? <div className="flex around">
                        <div onClick={e=> moveAndHide("/debug/pwa/")}>PWA</div>
                        <div onClick={e=> moveAndHide("/debug/push/")}>PUSH</div>
                    </div>
                    : <></>
                }
            </div>
        </>
    )
}